export default "__VITE_ASSET__35Gt$XL9__"